const { filterService } = require('../_services')
const regexConstant = require('../constants/regexes.constant')
const typeConstant = require('../constants/types.constant')

const filterSchema = {
  id: { type: 'string' },
  parentId: {
    type: 'string',
    pattern: regexConstant.mongoObjectId.source,
    required: true,
    queryKey: 'filters',
    getApi: filterService.query,
    options: {},
    keys: {
      name: 'parentName',
      _id: 'parentId',
    },
  },
  ancestorIds: { type: 'array', items: { type: 'string' } },
  name: { type: 'string', transform: ['trim'], required: true },
  nameAr: { type: 'string', transform: ['trim'], required: true },
  content: { type: 'content' },
  contentAr: { type: 'content' },
  title: { type: 'string', transform: ['trim'] },
  titleAr: { type: 'string', transform: ['trim'] },
  type: { type: 'string', enum: Object.values(typeConstant), required: true },
  coverPhoto: { type: 'file', accept: 'image/*', required: true },
  images: { type: 'file', accept: 'image/*' },
  videos: {
    type: 'array',
    items: { type: 'string', transform: ['trim'] },
    freeSolo: true,
  },
  createdAt: { type: ['string', 'null'], format: 'date-time' },
  // Phase 4: 125-char cap matches the server validator and Google's image
  // alt recommendation; the publish-time server check refuses status=online
  // until both are filled in.
  coverImageAlt: {
    type: 'string',
    transform: ['trim'],
    required: true,
    maxLength: 125,
  },
  coverImageAltAr: {
    type: 'string',
    transform: ['trim'],
    required: true,
    maxLength: 125,
  },
  windowTitle: { type: 'string', transform: ['trim'], required: true },
  windowTitleAr: { type: 'string', transform: ['trim'], required: true },
  metaDescription: { type: 'string', transform: ['trim'], required: true },
  metaDescriptionAr: { type: 'string', transform: ['trim'], required: true },
  h1: { type: 'string', transform: ['trim'] },
  h1Ar: { type: 'string', transform: ['trim'] },
  // Per-page robots directive (brief item 12). Server/client default is
  // "index, follow" when unset; status=offline always overrides to noindex
  // on the client regardless of this value.
  robotsMeta: {
    type: 'string',
    enum: [
      'index,follow',
      'noindex,follow',
      'noindex,nofollow',
      'index,nofollow',
    ],
  },
  status: {
    type: 'string',
    enum: ['online', 'offline', 'draft', 'scheduled'],
    required: true,
  },
  featured: { type: 'boolean' },
  publishedAt: { type: ['string', 'null'], format: 'date-time' },
  scheduledFor: { type: ['string', 'null'], format: 'date-time' },
  heading: { type: 'string', transform: ['trim'] },
  headingAr: { type: 'string', transform: ['trim'] },
  subheading: { type: 'string', transform: ['trim'] },
  subheadingAr: { type: 'string', transform: ['trim'] },
  ctaLabel: { type: 'string', transform: ['trim'] },
  ctaLabelAr: { type: 'string', transform: ['trim'] },
  ctaUrl: { type: 'string', transform: ['trim'] },
  order: { type: 'number' },
  heroTagline: { type: 'string', transform: ['trim'] },
  heroTaglineAr: { type: 'string', transform: ['trim'] },
  aboutUsBody: { type: 'content' },
  aboutUsBodyAr: { type: 'content' },
  aboutUsImage: { type: 'string', transform: ['trim'] },
  aboutUsImageAlt: { type: 'string', transform: ['trim'] },
  aboutUsImageAltAr: { type: 'string', transform: ['trim'] },
  designWorkIntro: { type: 'content' },
  designWorkIntroAr: { type: 'content' },
  fitoutIntro: { type: 'content' },
  fitoutIntroAr: { type: 'content' },
  servicesIntro: { type: 'content' },
  servicesIntroAr: { type: 'content' },
  blogIntro: { type: 'content' },
  blogIntroAr: { type: 'content' },
  // Phase 5 — LocalBusiness JSON-LD fields edited via /pages/homepage.
  localBusinessAddress: { type: 'string', transform: ['trim'] },
  localBusinessAddressAr: { type: 'string', transform: ['trim'] },
  localBusinessPhone: { type: 'string', transform: ['trim'] },
  localBusinessEmail: { type: 'string', transform: ['trim'] },
  localBusinessLogo: { type: 'string', transform: ['trim'] },
  localBusinessGeoLat: { type: 'number' },
  localBusinessGeoLng: { type: 'number' },
  // schema.org condensed OpeningHoursSpecification format, e.g. "Mo-Sa 09:00-18:00".
  localBusinessHours: { type: 'string', transform: ['trim'] },
}

module.exports = filterSchema
